import {
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST,
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS,
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
